var render = function render(){var _vm=this,_c=_vm._self._c;return _c('YLayoutBodyMenu',{attrs:{"menu":[
    {title:'基础配置',path:'/shop/plugin/dealer/conf'},
    {title:'经销商管理',path:'/shop/plugin/dealer/manage'},
    {title:'分红日志',path:'/shop/plugin/dealer/log'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }